export default __webpack_public_path__ + "static/media/dd2.6180c972.png";